// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13AdG","largestCol":"styles_largestCol__3yuVn","smallestCol":"styles_smallestCol__19aJE"};